// extracted by mini-css-extract-plugin
export var askAiIcon = "_pg-9";
export var container = "_pg-0";
export var groupSeparator = "_pg-a";
export var highlight = "_pg-4";
export var resultIcon = "_pg-5";
export var resultItem = "_pg-7";
export var resultSubtitle = "_pg-3";
export var resultTitle = "_pg-2";
export var resultsList = "_pg-1";
export var searchGroup = "_pg-6";
export var selected = "_pg-8";